"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _connectedReactRouter = require("connected-react-router");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxOidc = require("redux-oidc");

var _UserManager = _interopRequireDefault(require("../../oidc/UserManager"));

class Callback extends _react.default.Component {
  constructor() {
    super(...arguments);

    this.successCallback = user => {
      // the user object gets the browser's URL before
      // redirection was triggered passed into its state
      // when triggerAuthFlow is set to `true`
      const urlBeforeRedirection = user.state.path;
      this.props.dispatch((0, _connectedReactRouter.push)(urlBeforeRedirection));
    };

    this.errorCallback = error => {
      // TODO Create Error Component to display error messages reaturned from the server
      this.props.dispatch((0, _connectedReactRouter.push)('/'));
    };
  } // TODO Create a full page spinner component to show the redirect is in progress.


  render() {
    return /*#__PURE__*/_react.default.createElement(_reduxOidc.CallbackComponent, {
      userManager: _UserManager.default,
      successCallback: this.successCallback,
      errorCallback: this.errorCallback
    }, /*#__PURE__*/_react.default.createElement("div", null, "Redirecting"));
  }

}

var _default = (0, _reactRedux.connect)()(Callback);

exports.default = _default;